var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[(_vm.position > 500)?_c('div',{staticClass:"scrollTop"},[_c('div',{staticClass:"button",on:{"click":_vm.toTop}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }